module.exports = __webpack_public_path__ + "img/add-none.ad4bc8bd.png";